export const handleFormatHastag = (value: string) => (value?.[0] === '#' ? value.replace('#', '') : value);
